import React from "react";
import "./SidebarContent.scss";
import HtmlRenderer from "../../HtmlRenderer";
import { useLanguage } from "../../hooks/useLanguage";

const labels = {
  email: {
    da: "Email",
    en: "Email",
    de: "Email",
  },
  phone: {
    da: "Telefon",
    en: "Telephone",
    de: "Telefon",
  },
  openingHours: {
    da: "Åbningstider",
    en: "Opening hours",
    de: "Öffnungszeiten",
  },
  facilities: {
    da: "Faciliteter",
    en: "Facilities",
    de: "Anlagen",
  },
  seeWebpage: {
    da: "Se hjemmeside",
    en: "See website",
    de: "Siehe Website",
  },
  bookAccomodation: {
    da: "Book ophold",
    en: "Book accommodation",
    de: "Unterkunft buchen",
  },
};

/*
 * This component that displays the content of the sidebar
 * It is used for boatrentals, shops and accomodations
 */

const SidebarContent = (props) => {
  const language = useLanguage();

  const getWebsite = () => {
    let url = props.data.website;
    if (url && !/^(f|ht)tps?:\/\//i.test(url)) {
      url = "http://" + url;
    }
    return url;
  };

  let buttonText = labels.seeWebpage[language];

  if (props.data.type === "hotel")
    buttonText = labels.bookAccomodation[language];

  const facilities = props.data.facilities[language].map((f, i) => (
    <li key={i}>{f}</li>
  ));

  return (
    <div style={{ position: "relative", height: "100%", width: "100%" }}>
      <div id="certifiedHotel">
        <div className="header clearfix">
          <div>
            <h2 className="overskrift">{props.data.name}</h2>
          </div>

          <div className="headlineBar">
            <span className="label">{labels.email[language]}</span>
            <a href={"mailto:" + props.data.eMail}>
              <span className="data">{props.data.eMail}</span>
            </a>
          </div>
          <div className="headlineBar">
            <span className="label">{labels.phone[language]}</span>
            <span className="data">{props.data.telephone}</span>
          </div>
          <div className="headlineBar">
            <span className="label">{labels.openingHours[language]}</span>
            <span className="data">{props.data.openingHours}</span>
          </div>

          <div>
            <img
              src={props.data.picture}
              alt="Billede af hotel"
              className="hotelImage"
              style={{
                maxHeight: "200px",
                objectFit: "contain",
              }}
            />
          </div>

          <div>
            <p
              className="description"
              style={{
                whiteSpace: "pre-wrap",
              }}
            >
              <HtmlRenderer html={props.data.description[language]} />
            </p>
          </div>
          <div
            style={{
              display:
                props.data.facilities[language].length > 0 ? "block" : "none",
            }}
            className="facilities"
          >
            <h3>{labels.facilities[language]}:</h3>
            <div>
              <ul>{facilities}</ul>
            </div>
          </div>
        </div>
      </div>
      <div className="buttonContainer">
        <a href={getWebsite()} target="_blank" rel="noopener noreferrer">
          <button className="navButton">{buttonText}</button>
        </a>
      </div>
    </div>
  );
};

export default SidebarContent;
